module.exports = __webpack_public_path__ + "static/media/background-5.2e6db19d.jpg";